import { render, staticRenderFns } from "./readme.vue?vue&type=template&id=6a75f4c9&"
import script from "./readme.vue?vue&type=script&lang=js&"
export * from "./readme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports